<div class="register-success-container w-100">
    <div class="close-modal" (click)="closeModal()"><span>X</span></div>
    <div class="register-success">
        <div class="icon">
            <img src="assets/images/icons/checkmark_success.svg">
        </div>
        <div class="title-success mt-3">
                {{ 'Registro exitoso de tu frase e imagen de seguridad' |translate }}
        </div>
    </div>
</div>
